import { useLocation } from 'react-router-dom';
import { useMemo } from 'react';

// Routes that need non-standard layouts
// 'minimal' = no sidebar, stripped navbar (next-call, chat pages, or embedded iframes)
// 'embed'   = no sidebar, NO top navbar, full-width canvas for academy split-screen embedding
const LAYOUT_MODE_MAP = {
  '/next-call': 'minimal',
  '/next-call-v2': 'minimal',
  '/chat': 'minimal',
  '/lead-details-v2': 'minimal',
  '/lead-details': 'minimal',
  '/lead-details-embed': 'embed',
};

const useLayoutMode = () => {
  const { pathname, search } = useLocation();
  return useMemo(() => {
    const isEmbedded = typeof window !== 'undefined' && window.self !== window.top;
    const params = new URLSearchParams(search);

    // Explicit embed routes or query parameters: completely strip both side & top nav
    if (
      pathname.startsWith('/lead-details-embed') ||
      params.get('mode') === 'embed' ||
      params.get('embed') === 'true' ||
      (params.get('embedded') === 'true' && (params.get('hideNav') === 'true' || params.get('hideTopNav') === 'true'))
    ) {
      return 'embed';
    }

    if (
      isEmbedded ||
      params.get('embedded') === 'true' ||
      params.get('hideSidebar') === 'true' ||
      params.get('offline') === 'true'
    ) {
      return 'minimal';
    }

    for (const [route, mode] of Object.entries(LAYOUT_MODE_MAP)) {
      if (pathname === route || pathname.startsWith(route + '/')) return mode;
    }
    return 'default';
  }, [pathname, search]);
};

export default useLayoutMode;

